import { render, staticRenderFns } from "./DataSourceMapping.vue?vue&type=template&id=4b6e8dc0&scoped=true&"
import script from "./DataSourceMapping.vue?vue&type=script&lang=js&"
export * from "./DataSourceMapping.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceMapping.vue?vue&type=style&index=0&id=4b6e8dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e8dc0",
  null
  
)

export default component.exports